import NzRollReturnsSerializer from './base';

export default class RollReturn extends NzRollReturnsSerializer {}
